import * as Yup from 'yup';

export default Yup.object().shape({
  loadValue: Yup.number().required().moreThan(0, 'O valor deve ser maior que zero'),
  container: Yup.string().nullable(),
  document: Yup.string().required(),
  currency: Yup.string().required(),
  exchange: Yup.number().required(),
  originIbgeCode: Yup.string().optional().nullable(),
  originCityName: Yup.string().required(),
  originState: Yup.string().required(),
  originStateName: Yup.string().required(),
  originCountry: Yup.string().required(),
  destinationIbgeCode: Yup.string().optional().nullable(),
  destinationCityName: Yup.string().required(),
  destinationState: Yup.string().required(),
  destinationStateName: Yup.string().required(),
  destinationCountry: Yup.string().required(),
  type: Yup.string().oneOf(['NATIONAL', 'INTERNATIONAL']).required(),
});
